import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userId: null,
        displayname: null,
        picture: null,
        point: '0',
        level: '0',
        level_name: null,
        share: '0',
        c: null
    },
    actions: {
        // 使用liff 獲取使用者資料 //
        getUserid(state, user){
            liff.init(function (data) {
                //let userid = data.context.userId
                liff.getProfile().then((profile) => {
                    //alert("pro:" + JSON.stringify(profile))
                    let name = profile.displayName
                    let img = profile.pictureUrl
                    let userId = profile.userId
                    state.commit('getUserPro', {
                        displayName: name,
                        picture: img,
                        userid: userId
                    })
                })
                //state.commit('getUserid', userid)
            })
        },
        // 推薦者觸發推薦好友LIFF時, 記錄推薦人USID //
        recommend (state, contents) {
            setTimeout(() => {
                //alert("re_c:" + contents.c)
                let channelId = contents.c
                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/RecommendByLIFF'
                let postData = {
                    "ChannelID": channelId,
                    "USID": this.getters.userId
                }
                console.log(postData)
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    console.log(res)
                    //alert(JSON.stringify(res))  //[object object]
                });
            },1000);
        },
        // 成功推薦人數查詢 //
        numOfshare (state, contents) {
            setTimeout(() => {
                let channelId = contents.c
                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/LIFFNumberOfShare'
                let postData = {
                    "ChannelID": channelId,
                    "RecommenderUSID": this.getters.userId
                }
                //alert("Rec_channelId:" + channelId + "userid:" + this.getters.userId)
                console.log(postData)
                state.commit('getChannelId',channelId)
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    console.log(res)
                    //alert(res.data.ShareNumber)
                    state.commit('numOfshare', res.data.ShareNumber)
                    //alert(res)  //[object object]
                });
            },1000);
        }
    },
    getters: {
        userId(state) {
            //alert("get:" + state.userId)
            return state.userId
        },
        point(state) {
            if(state.share != 0){
                state.point = state.share * 10
            }
            return state.point
        },
        level(state) {
            if(state.point != 0) {
                state.level = Math.floor(state.point / 10)
            }
            return state.level
        },
        share(state) {
            return state.share
        },
        displayname(state) {
            return state.displayname
        },
        picture(state) {
            return state.picture
        },
        share(state) {
            return state.share
        },
        channelId(state) {
            return state.c
        }
    },
    mutations: {
        /*getUserid(state, user) {
            state.userId = user
            alert("mu_userid:" + state.userId)
        },*/
        getUserPro(state, user) {
            state.displayname = user.displayName
            state.picture = user.picture
            state.userId = user.userid
            //alert("getUserPro_userId" + state.userId)
        },
        userLevel(state, lv) {
            state.level = lv
            //alert("level:" + state.level)
        },
        numOfshare(state, share) {
            state.share = share
            //alert("share:" + state.share)
        },
        getChannelId(state, channel) {
            state.c = channel
            //alert("channel:\n" + state.c)
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js